var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1446",
    transform: "translate(-313 -449)",
    fill: "#97144d"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 169",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(313 449)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(320 462)",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))));
}
export default SvgInfoHover;